// Swap to the secondary image only when hovering the product card's image area
// (hovering the rest of the card does not swap). We use a delegated mousemove +
// bounding-rect check because the card's full-card link overlay intercepts pointer
// events over the media, so a plain `:hover` on the image container never fires.
let activeCard = null;

document.addEventListener('mousemove', (event) => {
  const target = event.target;
  const card = target && target.closest ? target.closest('.product-card-wrapper') : null;

  if (card !== activeCard) {
    if (activeCard) activeCard.classList.remove('card-media-hover');
    activeCard = card;
  }

  if (!card) return;

  const media = card.querySelector('.card__media');
  if (!media) return;

  const rect = media.getBoundingClientRect();
  const overMedia =
    event.clientX >= rect.left &&
    event.clientX <= rect.right &&
    event.clientY >= rect.top &&
    event.clientY <= rect.bottom;

  card.classList.toggle('card-media-hover', overMedia);
});
